import { LinearTransform } from '@st/geom'
import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'

const LinearTransformContext = createContext<LinearTransform>(LinearTransform.IDENTITY)

export function LinearTransformProvider({
  transform = LinearTransform.IDENTITY,
  children
}: {
  transform?: LinearTransform
  children?: ReactNode
}) {
  return (
    <LinearTransformContext.Provider value={transform}>{children}</LinearTransformContext.Provider>
  )
}

export function useLinearTransform() {
  return useContext(LinearTransformContext)
}
